import { render, staticRenderFns } from "./CommonSwitch.vue?vue&type=template&id=f063cb18&scoped=true&"
import script from "./CommonSwitch.vue?vue&type=script&lang=js&"
export * from "./CommonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CommonSwitch.vue?vue&type=style&index=0&id=f063cb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f063cb18",
  null
  
)

export default component.exports